export const scrollToId = (id) => (e) => {
    if (e) e.preventDefault();
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -76, duration: 1.2 });
    else el.scrollIntoView({ behavior: "smooth", block: "start" });
};
